// extracted by mini-css-extract-plugin
export var shine = "Video-module--shine--eea5c";
export var video__container = "Video-module--video__container--800d6";
export var video__iframe = "Video-module--video__iframe--5deca";
export var video__preview = "Video-module--video__preview--20a33";
export var video__preview__play = "Video-module--video__preview__play--387f5";